import React from 'react';

interface IdleWarningModalProps {
  secondsRemaining: number;
  onStay: () => void;
}

export default function IdleWarningModal({ secondsRemaining, onStay }: IdleWarningModalProps) {
  return (
    <div
      className="fixed inset-0 z-[19999] flex items-center justify-center bg-black/60"
      role="dialog"
      aria-modal="true"
      aria-labelledby="idle-warning-title"
    >
      <div className="mx-4 max-w-sm rounded-xl border border-yellow-500/50 bg-gray-900 p-6 text-center shadow-2xl">
        <h2 id="idle-warning-title" className="mb-2 text-xl font-bold text-white">
          Still there?
        </h2>
        <p className="mb-4 text-gray-300">
          You will be disconnected in{' '}
          <span className="font-semibold text-yellow-400">{secondsRemaining}</span> seconds due to
          inactivity.
        </p>
        <button
          type="button"
          onClick={onStay}
          className="rounded-lg bg-yellow-500 px-8 py-3 font-semibold text-gray-900 transition hover:bg-yellow-400"
        >
          Stay
        </button>
      </div>
    </div>
  );
}
